// extracted by mini-css-extract-plugin
export default {"container":"CategoriesContainer_container__yIJPk"};